// *Employee self-service homepage main component*

// NOTE:
// all components in ./components are a child of this component, main logic and data is stored here
// The avatar menu for mobile is directly imported and used here, while desktop avatar menu is imported
// in ./Components/HomeHead.js
// All styles are in ../../../../../Assets/Styles/Home.scss

// STATE NAMES:
// The state initially contains static color codes for profile image placeholder in child components,
// SizeOptions state for items per page select dropdown, and PageInfo state is for storing Pagination
// data similar to EmployeeList component. TabIds state is the id of the 3 main tabs (top jobs, top projects,
// top activities) and is used in functions inside a map() method to find the active tab and determine the type
// of JPA that the user is taking actions on ("position", "activity", "project") in API requests.

// NOTE:
// Page data is refreshed by clicking the active tab or active page number (based on requirements);
// function names: clickActivePage()
// Initialization functions to fetch data on mount are called inside useEffect hook.
// Every API call logs data to the console for tracking data exchange, request data and request status.

import React, { useState, useEffect, useCallback, useRef } from "react";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import SampleUser from "../../../../../Assets/Images/Ellipse 194.png";
import PlusCircle from "../../../../../Assets/Images/plus-circle.svg";
import UserAvatar from "../../../../../Assets/Images/sampleuser.png";
import "../../../../../Assets/Styles/Home.scss";
import { Config } from "../../../../../Config";
import axios from "axios";
import HomeHead from "./Components/HomeHead";
import MainContentHead from "./Components/MainContentHead";
import JPAItem from "./Components/JPAItem";
import DetailsModal from "./Components/DetailsModal";
import VerificationModal from "./Components/VerificationModal";
import Select from "../../ShareElements/Select/Select";
import ProfileImageUploader from "./Components/ProfileImageUploader";
import MobileAvatarMenu from "./Components/MobileAvatarMenu";
import RecentViewedCard from "./Components/RecentViewedCard";
import HeaderImageUploader from "./Components/HeaderImageUploader";
import VerifyCancelModaL from "./Components/VerifyCancelModal";
import InterviewModal from "./Components/InterviewModal";
import ConfirmResetModal from "./Components/ConfirmResetModal";
import ConfirmMessageModal from "./Components/ConfirmSendMessage";
import FormEmptyState from "../../ShareElements/EmptyState/FormEmptyState";
import LoadingIndicatorCircle from "../../ShareElements/LoadingIndicator/LoadingIndicatorCircle";
import JPAItemsGuide from "../../UserGuide/Components/JPAItemsGuide";
import FooterJPAsGuide from "../../UserGuide/Components/FooterJPAsGuide";
import Slider from "react-slick";
import AvailabilityModal from "../../RecruiterJPAdetails/Components/AvailabilityModal";
import AvailabilityIcon from "../../../../../Assets/Images/more_time_silver.svg";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";

const ESSHome = (props) => {
  const sliderRef = useRef(null);
  const [UserInfo, setUserInfo] = useState();
  const [EmployeePos, setEmployeePos] = useState();
  const [HeaderEditorIsOpen, setHeaderEditorIsOpen] = useState(false);
  const [UploadedHeaderImage, setHeaderImage] = useState();
  const [AvatarEditIsOpen, setAvatrEditIsOpen] = useState(false);
  const [UploadedAvatar, setUploadedAvatar] = useState();
  const [MobileAvatarMenuIsOpen, setMobileAvatarMenuIsOpen] = useState(false);
  const [Jobs, setJobs] = useState([]);
  const [Projects, setProjects] = useState([]);
  const [Activities, setActivities] = useState([]);
  const [TotalJobs, setTotalJobs] = useState();
  const [TotalProjects, setTotalProjects] = useState();
  const [TotalActivities, setTotalActivities] = useState();
  const [TotalElements, setTotalElements] = useState(); // the number displayed on active tabs for (JPA)
  const [DetailsIsOpen, setDetailsIsOpen] = useState(false);
  const [VerifyIsOpen, setVerifyIsOpen] = useState(false);
  const [VerifyInterviewIsOpen, setVerifyInterviewIsOpen] = useState(false);
  const [InterviewDecision, setInterViewDecision] = useState("");
  const [Details, setDetails] = useState({});
  const [RequestedItem, setRequestedItem] = useState();
  const [RecentJPAs, setRecentJPAs] = useState([]);
  const [PopularJPAs, setPopularJPAs] = useState([]);
  const [ApplyingJobInfo, setApplyingJobInfo] = useState();
  const [RecentIsActive, setRecentIsActive] = useState(true); //recently viewed tabs boolean
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });
  const Colors = [
    { bg: "#B9D3FA", text: "#6DA2F2" },
    { bg: "#FFE0E0", text: "#DE8C8C" },
    { bg: "#CDFFCC", text: "#68D966" },
    { bg: "#FFFFC2", text: "#D6D65E" },
    { bg: "#E1CFFF", text: "#A781E3" },
    { bg: "#E4F7F2", text: "#71D9BB" },
    { bg: "#FFE3B3", text: "#D9B16C" },
    { bg: "#D1F0FF", text: "#60B3DB" },
  ];
  const [CatIds] = useState(["cat-1", "cat-2", "cat-3"]);
  const [Pages, setPages] = useState([]);
  const [ApplicationType, setApplicationType] = useState("");
  const [SizeOptions] = useState([
    { name: 4, id: 4 },
    { name: 8, id: 8 },
    { name: 16, id: 16 },
  ]);
  const [TabIds] = useState(["jobs-tab", "projects-tab", "activities-tab"]);
  const [CancelModalIsOpen, setCancelModalIsOpen] = useState(false);
  const [ApplicationToCancel, setApplicationToCancel] = useState({});
  const [AvatarURL, setAvatarURL] = useState("");
  const [HeaderURL, setHeaderURL] = useState("");
  const [ConfirmResetIsOpen, setConfirmResetIsOpen] = useState(false);
  const [ApplicationToReset, setApplicationToReset] = useState();
  const [VerifyConnectionIsOpen, setVerifyConnectIsOpen] = useState(false);
  const [JobResultIsEmpty, setJobResIsEmpty] = useState(false);
  const [ProjectResultIsEmpty, setProjectResIsEmpty] = useState(false);
  const [ActivityResultIsEmpty, setActivityResIsEmpty] = useState(false);
  const [NotificationJPAFilterIsActive, setNotificationJPAFilterIsActive] =
    useState(false); // used for counterIds filter displaying
  const [MoreLikeThisIsActive, setMoreLikeThisIsActive] = useState(false);
  const [MoreLikeThisTitle, setMoreLikeThisTitle] = useState("");
  const [MoreLikeThisId, setMoreLikeThisId] = useState("");
  const [LoadingIsShown, setLoadingIsShown] = useState(false);
  // the following 3 states are only used for the case where the initial load (API call) of the
  // JPA recommendations are empty, means there are no JPA to recommend to this user, it is for
  // showing a different empty state message.
  const [JobsInitEmpty, setJobsInitEmpty] = useState(false);
  const [ProjectsInitEmpty, setProjectsInitEmpty] = useState(false);
  const [ActivitiesInitEmpty, setActivitiesInitEmpty] = useState(false);
  const [UpdateDateTime, setUpdateDateTime] = useState(undefined);
  const [ReactionReasons, setReactionReasons] = useState([]); // reasons for likes/dislikes
  const [AvailabilityModalIsOpen, setAvailabilityModalIsOpen] = useState(false);
  const [RequestedAvailabilityDetails, setRequestedAvailabilityDetails] =
    useState();
  const [MSSSummary, setMSSSummary] = useState({
    totalApplications: 0,
    totalCandidateRecommendations: 0,
    totalJpaRecommendations: 0,
  });

  const CarouselConfig = {
    dots: false,
    infinite: false,
    slidesToScroll: 2,
    slidesToShow: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 2,
          vertical: true,
          verticalSwiping: true,
          swipeToSlide: true,
          onReInit: () => {
            document.getElementsByClassName("slick-track")[0].style.height =
              "auto";
          },
        },
      },
    ],
    beforeChange: (_, next) => {
      if (next > 0) {
        document
          .getElementById("prev-row")
          .classList.remove("disabled-row-switch");
      } else {
        document
          .getElementById("prev-row")
          .classList.add("disabled-row-switch");
      }

      if (RecentIsActive) {
        // we add (-3) because "next" watch the most left card only
        if (next === RecentJPAs.length - 3 || RecentJPAs.length <= 3) {
          document
            .getElementById("next-row")
            .classList.add("disabled-row-switch");
        } else {
          document
            .getElementById("next-row")
            .classList.remove("disabled-row-switch");
        }
      } else {
        if (next === PopularJPAs.length - 3 || PopularJPAs.length <= 3) {
          document
            .getElementById("next-row")
            .classList.add("disabled-row-switch");
        } else {
          document
            .getElementById("next-row")
            .classList.remove("disabled-row-switch");
        }
      }
    },
  };

  useEffect(() => {
    getUserInfo();
    setTimeout(() => {
      fetchJobs(
        "Initial",
        0,
        4,
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
      fetchProjects(
        0,
        4,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
      fetchActivities(
        0,
        4,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
    }, 200);
    fetchPopularJPAs();
    getUserImage();
    getUserHeader();
    fetchEmpPositionInfo();
    removeLocalStorageItems();
    fetchUpdateDateTime();
    fetchReactionReasons();

    return () => {
      window.localStorage.removeItem("RedirectToken");
      window.localStorage.removeItem("notification_jpa_search_data");
    };
  }, []);

  const updateJPAs = () => {
    let Size = parseInt(document.getElementById("row-per-page-filter").value);
    if (document.getElementById("jobs-tab").classList.contains("active")) {
      fetchJobs("Initial", 0, Size);
    } else if (
      document.getElementById("projects-tab").classList.contains("active")
    ) {
      fetchProjects(0, Size);
    } else {
      fetchActivities(0, Size);
    }
  };

  // populates the state item related to reaction reasons. only called once on component mount
  const fetchReactionReasons = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/reaction-reasons",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setReactionReasons(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchUpdateDateTime = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/services-monitoring/ai-services/jpa-recommendations",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setUpdateDateTime(Res.data.lastUpdate);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const checkNotificationRedirect = (UserInfoRes) => {
    if (
      window.localStorage.getItem("RedirectToken") !== "undefined" &&
      window.localStorage.getItem("RedirectToken") !== null
    ) {
      // This item is set to "undefined" on the login page
      // where there is no url param detected for redirection.
      let RedirectInfo = JSON.parse(
        atob(window.localStorage.getItem("RedirectToken"))
      );

      if (RedirectInfo.loggedInEmployeeId === UserInfoRes.id) {
        setMoreLikeThisIsActive(false);
        if (RedirectInfo.redirectTo === "HOMEPAGE") {
          if (RedirectInfo.jpaType === "position") {
            document.getElementById("search-input").value =
              RedirectInfo.jpaTitle;
            document
              .getElementById("search-placeholder")
              .classList.add("hidden");
            document.getElementById("clear-btn").classList.remove("hidden");
            setTimeout(() => {
              document.getElementById("jobs-tab").click();
            }, 200);
          } else if (RedirectInfo.jpaType === "project") {
            document.getElementById("projects-tab").click();
            document.getElementById("search-input").value =
              RedirectInfo.jpaTitle;
            document
              .getElementById("search-placeholder")
              .classList.add("hidden");
            document.getElementById("clear-btn").classList.remove("hidden");
            setTimeout(() => {
              fetchProjects(0, 4, true, MoreLikeThisIsActive);
            }, 200);
          } else if (RedirectInfo.jpaType === "activity") {
            document.getElementById("activities-tab").click();
            document.getElementById("search-input").value =
              RedirectInfo.jpaTitle;
            document
              .getElementById("search-placeholder")
              .classList.add("hidden");
            document.getElementById("clear-btn").classList.remove("hidden");
            setTimeout(() => {
              fetchActivities(0, 4, true, MoreLikeThisIsActive);
            }, 200);
          }
        } else if (RedirectInfo.redirectTo === "JPA_CANDIDATES") {
          window.localStorage.setItem("CreatedJPAId", RedirectInfo.jpaId);

          if (RedirectInfo.jpaType === "position") {
            document.getElementById("to-job-candidates").click();
          } else if (RedirectInfo.jpaType === "project") {
            document.getElementById("to-project-candidates").click();
          } else if (RedirectInfo.jpaType === "activity") {
            document.getElementById("to-activity-candidates").click();
          }
        } else if (RedirectInfo.redirectTo === "JPA_DETAILS") {
          window.localStorage.setItem("JPAItemId", RedirectInfo.jpaId);
          window.localStorage.setItem(
            "notif_candidate_name",
            RedirectInfo.candidateName
          );

          if (RedirectInfo.jpaType === "position") {
            document.getElementById("to-job-details").click();
          } else if (RedirectInfo.jpaType === "project") {
            document.getElementById("to-project-details").click();
          } else if (RedirectInfo.jpaType === "activity") {
            document.getElementById("to-activity-details").click();
          }
        }
      }
      window.localStorage.removeItem("RedirectToken");
    }
  };

  const removeLocalStorageItems = () => {
    window.localStorage.removeItem("chat_jpaId");
    window.localStorage.removeItem("chat_recipientId");
    window.localStorage.removeItem("EmpFilesUploaded");
    window.localStorage.removeItem("PosFilesUploaded");
    window.localStorage.removeItem("chat_workCiy");
    window.localStorage.removeItem("chat_title");
    window.localStorage.removeItem("chat_jpaType");
    window.localStorage.removeItem("chat_source");
    window.localStorage.removeItem("TempChatroom");
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updatePaginationActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updatePaginationActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
  };

  const fetchEmpPositionInfo = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/current-position",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setEmployeePos(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchRecentJPAs = () => {
    var ActiveTab;
    TabIds.map((Tab) => {
      if (document.getElementById(Tab) === null) {
        ActiveTab = "jobs-tab";
      } else {
        if (document.getElementById(Tab).classList.contains("active")) {
          ActiveTab = Tab;
        }
      }
    });
    let URLparam;
    if (ActiveTab === "jobs-tab") {
      URLparam =
        Config.PositionServiceURL + "/api/position/recommendation/recent-views";
    } else if (ActiveTab === "projects-tab") {
      URLparam =
        Config.ProjectServiceURL + "/api/project/recommendation/recent-views";
    } else {
      URLparam =
        Config.ActivityServiceURL + "/api/activity/recommendation/recent-views";
    }
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + URLparam,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };
    axios(Req)
      .then((Res) => {
        // console.log("Recent : ", Res);
        setRecentJPAs(Res.data.recommendations);
        handleScrollRecent("left");
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchPopularJPAs = () => {
    var ActiveTab;
    TabIds.map((Tab) => {
      if (document.getElementById(Tab) === null) {
        ActiveTab = "jobs-tab";
      } else {
        if (document.getElementById(Tab).classList.contains("active")) {
          ActiveTab = Tab;
        }
      }
    });
    let URLparam;
    if (ActiveTab === "jobs-tab") {
      URLparam =
        Config.PositionServiceURL + "/api/position/recommendation/popular";
    } else if (ActiveTab === "projects-tab") {
      URLparam =
        Config.ProjectServiceURL + "/api/project/recommendation/popular";
    } else {
      URLparam =
        Config.ActivityServiceURL + "/api/activity/recommendation/popular";
    }
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + URLparam,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        size: 15,
        start: 0,
      },
    };
    axios(Req)
      .then((Res) => {
        // console.log("Popular : ", Res);
        setPopularJPAs(Res.data.recommendations);
        handleScrollRecent("left");
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchJobs = (
    Status,
    Start,
    Size,
    IsMoreLikeThis,
    MoreLikeThisItemId,
    WillAnimate,
    IsSavedOnly,
    IsInitial
  ) => {
    let Keyword = "";
    if (document.getElementById("search-input") !== null) {
      Keyword = document.getElementById("search-input").value;
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recommendation/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          titleLike: Keyword,
        },
        size: Size,
        start: Start,
        sorts: [
          {
            direction: "DESC",
            fieldName: "similarity",
          },
        ],
      },
    };

    if (returnSelectedCategory() === "cat-1") {
      if (Req.data.criteria.category) {
        delete Req.data.criteria.category;
      }
    } else if (returnSelectedCategory() === "cat-2") {
      Req.data.criteria.category = "EXPLOITATION";
    } else if (returnSelectedCategory() === "cat-3") {
      Req.data.criteria.category = "EXPLORATION";
    }

    if (IsSavedOnly) {
      Req.data.criteria.onlyBookmarked = true;
    }

    // requesting more like this jpa item
    if (IsMoreLikeThis) {
      //removing the localstorage item since it's not required anymore and hiding the filter element
      window.localStorage.removeItem("notification_jpa_search_data");
      setNotificationJPAFilterIsActive(false);

      document.getElementById("top-jobs").classList.remove("translate-right");

      if (!MoreLikeThisItemId) {
        MoreLikeThisItemId = MoreLikeThisId;
      }
      Req.baseURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recommendation/" +
        MoreLikeThisItemId +
        "/similar";
    }

    // checking notification redirect for counterIds related to this type of JPA
    if (window.localStorage.getItem("notification_jpa_search_data") !== null) {
      let RedirectInfo = JSON.parse(
        atob(window.localStorage.getItem("notification_jpa_search_data"))
      );
      if (RedirectInfo.jpa_type === "POSITION") {
        Req.data.criteria.ids = RedirectInfo.counterIds;
        setNotificationJPAFilterIsActive(true);
      } else {
        setNotificationJPAFilterIsActive(false);
      }
    }

    axios(Req)
      .then((Res) => {
        setJobs([]);
        console.log("jobs", Res);
        setJobs(Res.data.results);
        setTotalJobs(Res.data.totalElements);

        if (IsMoreLikeThis) {
          setLoadingIsShown(false);
        }

        if (Status === "Initial") {
          setTotalElements(Res.data.totalElements);
          updatePages(Res.data.totalElements, 4, true);
          if (
            document.getElementById("jobs-tab") !== null &&
            document.getElementById("jobs-tab").classList.contains("active")
          ) {
            setTimeout(() => {
              if (document.getElementById("jobs-tab")) {
                document.getElementById("jobs-tab").click();
              }
            }, 500);
          }
        } else {
          updatePages(Res.data.totalElements, Size, true);
        }
        fetchRecentJPAs();
        fetchPopularJPAs();

        if (document.getElementById("jobs-tab").classList.contains("active")) {
          setTotalElements(Res.data.totalElements);
        }
        if (Res.data.results.length === 0) {
          setJobResIsEmpty(true);
          document.getElementById("info-footer").style.display = "none";
        } else {
          setJobResIsEmpty(false);
          if (window.innerWidth <= 550) {
            document.getElementById("info-footer").style.display = "grid";
          } else {
            document.getElementById("info-footer").style.display = "flex";
          }
        }
        if (Start === 0) {
          document.getElementById("start").innerHTML = "1";
          document.getElementById("end").innerHTML = Size;
          document
            .getElementById("prev-page")
            .classList.add("page-btn-disabled");
        } else {
          if (parseInt(Start + Size) > parseInt(Res.data.totalElements)) {
            document.getElementById("start").innerHTML = Start + 1;
            document.getElementById("end").innerHTML = parseInt(
              Start + Res.data.results.length
            );
          } else {
            document.getElementById("start").innerHTML = Start + 1;
            document.getElementById("end").innerHTML = parseInt(Start + Size);
          }
        }
        if (Res.data.totalElements < Size) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
        }

        document.getElementById("top-jobs").style.display = "flex";
        document.getElementById("top-activities").style.display = "none";
        document.getElementById("top-projects").style.display = "none";
        document.getElementById("top-jobs").style.opacity = "1";
        document.getElementById("top-activities").style.opacity = "0";
        document.getElementById("top-projects").style.opacity = "0";

        if (WillAnimate) {
          document.getElementById("top-jobs").classList.add("translate-right");
          setTimeout(() => {
            document
              .getElementById("top-jobs")
              .classList.remove("translate-right");
          }, 1000);
        }

        if (IsInitial && Res.data.results.length === 0) {
          setJobsInitEmpty(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchProjects = (
    Start,
    Size,
    WillResetPagination,
    IsMoreLikeThis,
    MoreLikeThisItemId,
    WillAnimate,
    IsSavedOnly,
    IsInitial
  ) => {
    let Keyword = "";
    if (document.getElementById("search-input") !== null) {
      Keyword = document.getElementById("search-input").value;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/recommendation/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          titleLike: Keyword,
        },
        size: Size,
        start: Start,
        sorts: [
          {
            direction: "DESC",
            fieldName: "similarity",
          },
        ],
      },
    };

    if (returnSelectedCategory() === "cat-1") {
      if (Req.data.criteria.category) {
        delete Req.data.criteria.category;
      }
    } else if (returnSelectedCategory() === "cat-2") {
      Req.data.criteria.category = "EXPLOITATION";
    } else if (returnSelectedCategory() === "cat-3") {
      Req.data.criteria.category = "EXPLORATION";
    }
    if (IsSavedOnly) {
      Req.data.criteria.onlyBookmarked = true;
    }

    // requesting more like this jpa item
    if (IsMoreLikeThis) {
      //removing the localstorage item since it's not required anymore and hiding the filter element
      window.localStorage.removeItem("notification_jpa_search_data");
      setNotificationJPAFilterIsActive(false);

      document
        .getElementById("top-projects")
        .classList.remove("translate-right");

      if (!MoreLikeThisItemId) {
        MoreLikeThisItemId = MoreLikeThisId;
      }
      Req.baseURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/recommendation/" +
        MoreLikeThisItemId +
        "/similar";
    }

    // checking notification redirect for counterIds related to this type of JPA
    if (window.localStorage.getItem("notification_jpa_search_data") !== null) {
      let RedirectInfo = JSON.parse(
        atob(window.localStorage.getItem("notification_jpa_search_data"))
      );
      if (RedirectInfo.jpa_type === "PROJECT") {
        Req.data.criteria.ids = RedirectInfo.counterIds;
        setNotificationJPAFilterIsActive(true);
      } else {
        setNotificationJPAFilterIsActive(false);
      }
    }

    axios(Req)
      .then((Res) => {
        setProjects([]);
        console.log(Res);
        setProjects(Res.data.results);
        setTotalProjects(Res.data.totalElements);

        if (IsMoreLikeThis) {
          setLoadingIsShown(false);
        }

        setTotalElements(Res.data.totalElements);
        if (WillResetPagination) {
          updatePages(Res.data.totalElements, Size, true);
          if (
            document.getElementById("projects-tab") !== null &&
            document.getElementById("projects-tab").classList.contains("active")
          ) {
            setTimeout(() => {
              document.getElementById("projects-tab").click();
            }, 500);
          }
        } else {
          updatePages(Res.data.totalElements, Size, true);
        }
        fetchRecentJPAs();
        fetchPopularJPAs();

        if (Start === 0) {
          if (document.getElementById("start")) {
            document.getElementById("start").innerHTML = "1";
            document.getElementById("end").innerHTML = Size;
            document
              .getElementById("prev-page")
              .classList.add("page-btn-disabled");
          }
        } else {
          if (parseInt(Start + Size) > parseInt(Res.data.totalElements)) {
            document.getElementById("start").innerHTML = Start + 1;
            document.getElementById("end").innerHTML = parseInt(
              Start + Res.data.results.length
            );
          } else {
            document.getElementById("start").innerHTML = Start + 1;
            document.getElementById("end").innerHTML = parseInt(Start + Size);
          }
        }
        if (Res.data.totalElements < Size && document.getElementById("end")) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
        }
        if (document.getElementById("info-footer")) {
          if (Res.data.results.length === 0) {
            setProjectResIsEmpty(true);
            document.getElementById("info-footer").style.display = "none";
          } else {
            if (window.innerWidth <= 550) {
              document.getElementById("info-footer").style.display = "grid";
            } else {
              document.getElementById("info-footer").style.display = "flex";
            }
            setProjectResIsEmpty(false);
          }
        }
        document.getElementById("top-jobs").style.display = "none";
        document.getElementById("top-activities").style.display = "none";
        document.getElementById("top-projects").style.display = "flex";
        document.getElementById("top-jobs").style.opacity = "0";
        document.getElementById("top-activities").style.opacity = "0";
        document.getElementById("top-projects").style.opacity = "1";

        if (WillAnimate) {
          document
            .getElementById("top-projects")
            .classList.add("translate-right");
        }
        setTimeout(() => {
          if (document.getElementById("top-projects")) {
            document
              .getElementById("top-projects")
              .classList.remove("translate-right");
          }
        }, 1000);

        if (IsInitial && Res.data.results.length === 0) {
          setProjectsInitEmpty(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchActivities = (
    Start,
    Size,
    WillResetPagination,
    IsMoreLikeThis,
    MoreLikeThisItemId,
    WillAnimate,
    IsSavedOnly,
    IsInitial
  ) => {
    let Keyword = "";
    if (document.getElementById("search-input") !== null) {
      Keyword = document.getElementById("search-input").value;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/recommendation/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          titleLike: Keyword,
        },
        size: Size,
        start: Start,
        sorts: [
          {
            direction: "DESC",
            fieldName: "similarity",
          },
        ],
      },
    };

    if (returnSelectedCategory() === "cat-1") {
      if (Req.data.criteria.category) {
        delete Req.data.criteria.category;
      }
    } else if (returnSelectedCategory() === "cat-2") {
      Req.data.criteria.category = "EXPLOITATION";
    } else if (returnSelectedCategory() === "cat-3") {
      Req.data.criteria.category = "EXPLORATION";
    }

    if (IsSavedOnly) {
      Req.data.criteria.onlyBookmarked = true;
    }

    // requesting more like this jpa item
    if (IsMoreLikeThis) {
      //removing the localstorage item since it's not required anymore and hiding the filter element
      window.localStorage.removeItem("notification_jpa_search_data");
      setNotificationJPAFilterIsActive(false);

      document
        .getElementById("top-activities")
        .classList.remove("translate-right");

      if (!MoreLikeThisItemId) {
        MoreLikeThisItemId = MoreLikeThisId;
      }
      Req.baseURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/recommendation/" +
        MoreLikeThisItemId +
        "/similar";
    }

    // checking notification redirect for counterIds related to this type of JPA
    if (window.localStorage.getItem("notification_jpa_search_data") !== null) {
      let RedirectInfo = JSON.parse(
        atob(window.localStorage.getItem("notification_jpa_search_data"))
      );
      if (RedirectInfo.jpa_type === "ACTIVITY") {
        Req.data.criteria.ids = RedirectInfo.counterIds;
        setNotificationJPAFilterIsActive(true);
      } else {
        setNotificationJPAFilterIsActive(false);
      }
    }

    axios(Req)
      .then((Res) => {
        setActivities([]);
        console.log(Res);
        setActivities(Res.data.results);
        setTotalActivities(Res.data.totalElements);

        if (IsMoreLikeThis) {
          setLoadingIsShown(false);
        }

        setTotalElements(Res.data.totalElements);
        if (WillResetPagination) {
          updatePages(Res.data.totalElements, Size, true);
          if (
            document.getElementById("activities-tab") !== null &&
            document
              .getElementById("activities-tab")
              .classList.contains("active")
          ) {
            setTimeout(() => {
              document.getElementById("activities-tab").click();
            }, 500);
          }
        } else {
          updatePages(Res.data.totalElements, Size, true);
        }
        fetchRecentJPAs();
        fetchPopularJPAs();
        if (Start === 0) {
          document.getElementById("start").innerHTML = "1";
          document.getElementById("end").innerHTML = Size;
          document
            .getElementById("prev-page")
            .classList.add("page-btn-disabled");
        } else {
          if (parseInt(Start + Size) > parseInt(Res.data.totalElements)) {
            document.getElementById("start").innerHTML = Start + 1;
            document.getElementById("end").innerHTML = parseInt(
              Start + Res.data.results.length
            );
          } else {
            document.getElementById("start").innerHTML = Start + 1;
            document.getElementById("end").innerHTML = parseInt(Start + Size);
          }
        }
        if (Res.data.totalElements < Size) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
        }
        if (Res.data.results.length === 0) {
          document.getElementById("info-footer").style.display = "none";
          setActivityResIsEmpty(true);
        } else {
          if (window.innerWidth <= 550) {
            document.getElementById("info-footer").style.display = "grid";
          } else {
            document.getElementById("info-footer").style.display = "flex";
          }
          setActivityResIsEmpty(false);
        }
        document.getElementById("top-jobs").style.display = "none";
        document.getElementById("top-activities").style.display = "flex";
        document.getElementById("top-projects").style.display = "none";
        document.getElementById("top-jobs").style.opacity = "0";
        document.getElementById("top-activities").style.opacity = "1";
        document.getElementById("top-projects").style.opacity = "0";

        if (WillAnimate) {
          document
            .getElementById("top-activities")
            .classList.add("translate-right");
        }
        setTimeout(() => {
          if (document.getElementById("top-activities")) {
            document
              .getElementById("top-activities")
              .classList.remove("translate-right");
          }
        }, 1000);

        if (IsInitial && Res.data.results.length === 0) {
          setActivitiesInitEmpty(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // only called when switching tabs, to reset the data displayed on the jobs tab and prevent
  // displaying old searched/filtered jobs on switching back to jobs tab.
  const updateJobs = (Start, Size) => {
    let Keyword = "";
    if (document.getElementById("search-input") !== null) {
      Keyword = document.getElementById("search-input").value;
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recommendation/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          titleLike: Keyword,
        },
        size: Size,
        start: Start,
        sorts: [
          {
            direction: "DESC",
            fieldName: "similarity",
          },
        ],
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setTimeout(() => {
          setJobs(Res.data.results);
        }, 500);
        // setTotalJobs(Res.data.totalElements);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // only called when switching tabs, to reset the data displayed on the projects tab and prevent
  // displaying old searched/filtered projects on switching back to projects tab.
  const updateProjects = (Start, Size) => {
    let Keyword = "";
    if (document.getElementById("search-input") !== null) {
      Keyword = document.getElementById("search-input").value;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/recommendation/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          titleLike: Keyword,
        },
        size: Size,
        start: Start,
        sorts: [
          {
            direction: "DESC",
            fieldName: "similarity",
          },
        ],
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setTimeout(() => {
          setProjects(Res.data.results);
        }, 500);
        // setTotalProjects(Res.data.totalElements);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // only called when switching tabs, to reset the data displayed on the activities tab and prevent
  // displaying old searched/filtered activities on switching back to activities tab.
  const updateActivities = (Start, Size) => {
    let Keyword = "";
    if (document.getElementById("search-input") !== null) {
      Keyword = document.getElementById("search-input").value;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/recommendation/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          titleLike: Keyword,
        },
        size: Size,
        start: Start,
        sorts: [
          {
            direction: "DESC",
            fieldName: "similarity",
          },
        ],
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setTimeout(() => {
          setActivities(Res.data.results);
        }, 500);
        // setTotalActivities(Res.data.totalElements);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleSizeChange = useCallback(() => {
    let BookmarkedOnly;
    if (document.getElementById("saved-switch-holder").classList.length === 1) {
      BookmarkedOnly = true;
    } else {
      BookmarkedOnly = false;
    }
    let ActiveTab;
    TabIds.map((Tab) => {
      if (document.getElementById(Tab).classList.contains("active")) {
        ActiveTab = Tab;
      }
    });
    let Size = parseInt(document.getElementById("row-per-page-filter").value);
    if (ActiveTab === "jobs-tab") {
      if (BookmarkedOnly) {
        fetchBookmarkedJobs(0);
      } else {
        fetchJobs(null, 0, Size, MoreLikeThisIsActive);
      }
    }
    if (ActiveTab === "projects-tab") {
      if (BookmarkedOnly) {
        fetchBookmarkedProjects(0);
      } else {
        fetchProjects(0, Size, true, MoreLikeThisIsActive);
      }
    }
    if (ActiveTab === "activities-tab") {
      if (BookmarkedOnly) {
        fetchBookmarkedActivities(0);
      } else {
        fetchActivities(0, Size, true, MoreLikeThisIsActive);
      }
    }
    updatePages(TotalElements, Size);
    if (document.getElementById("1-page-btn") !== null) {
      document.getElementById("1-page-btn").click();
    }
  }, [TotalElements]);

  const updatePages = (
    TotalItems,
    Size,
    IsInitial,
    WillClickPageOne,
    WillToggleTab
  ) => {
    let Count = Math.ceil(TotalItems / Size);
    let PagesArray = [];
    for (let i = 1; i <= Count; i++) {
      PagesArray.push(i);
    }
    setPages(PagesArray);
    if (IsInitial) {
      // it's first page load and this function creates the first PageInfo data
      shortenPagination(PagesArray);
    }
    if (WillClickPageOne) {
      setTimeout(() => {
        if (document.getElementById("1-page-btn") !== null) {
          document.getElementById("1-page-btn").click();
        }
      }, 300);
    }
    if (WillToggleTab) {
      if (tabIsActive("jobs-tab")) {
        document.getElementById("jobs-tab").click();
      } else if (tabIsActive("projects-tab")) {
        document.getElementById("projects-tab").click();
      } else if (tabIsActive("activities-tab")) {
        document.getElementById("activities-tab").click();
      }
    }
  };

  const requestPageNumber = (RequestedPage) => {
    let BookmarkedOnly;
    if (document.getElementById("saved-switch-holder").classList.length === 1) {
      BookmarkedOnly = true;
    } else {
      BookmarkedOnly = false;
    }
    let ActiveTab;
    TabIds.map((Tab) => {
      if (document.getElementById(Tab).classList.contains("active")) {
        ActiveTab = Tab;
      }
    });
    let Size = parseInt(document.getElementById("row-per-page-filter").value);
    let NewStart;
    if (RequestedPage === 1) {
      NewStart = 0;
    } else {
      NewStart = parseInt((RequestedPage - 1) * Size);
    }
    if (ActiveTab === "jobs-tab") {
      if (BookmarkedOnly) {
        fetchBookmarkedJobs(NewStart);
      } else {
        fetchJobs(null, NewStart, Size, MoreLikeThisIsActive);
      }
    }
    if (ActiveTab === "projects-tab") {
      if (BookmarkedOnly) {
        fetchBookmarkedProjects(NewStart);
      } else {
        fetchProjects(NewStart, Size, false, MoreLikeThisIsActive);
      }
    }
    if (ActiveTab === "activities-tab") {
      if (BookmarkedOnly) {
        fetchBookmarkedActivities(NewStart);
      } else {
        fetchActivities(NewStart, Size, false, MoreLikeThisIsActive);
      }
    }
    updatePaginationActiveClass(RequestedPage);
    updatePaginationNavButtons(RequestedPage);
    updatePaginationlength(RequestedPage);
  };

  const updatePaginationActiveClass = (ActivePage) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
      if (document.getElementById(ActivePage + "-page-btn") !== null) {
        document
          .getElementById(ActivePage + "-page-btn")
          .classList.add("active-page");
      }
    }
  };

  const updatePaginationNavButtons = (ActivePage) => {
    if (ActivePage === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    if (Pages.length === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
      document.getElementById("next-page").classList.add("page-btn-disabled");
    }
    if (Pages.length > 1 && ActivePage > 1) {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
    if (ActivePage === Pages.length) {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("next-page").classList.add("page-btn-disabled");
    }
    if (ActivePage === 1 && Pages.length > 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const requestNextPage = () => {
    for (let i = 1; i <= Pages.length; i++) {
      if (
        document.getElementById(i + "-page-btn") !== null &&
        document
          .getElementById(i + "-page-btn")
          .classList.contains("active-page")
      ) {
        if (document.getElementById(parseInt(i + 1) + "-page-btn") !== null) {
          setTimeout(() => {
            document.getElementById(parseInt(i + 1) + "-page-btn").click();
          }, 100);
        }
      }
    }
  };
  const requestPrevPage = () => {
    for (let i = 1; i <= Pages.length; i++) {
      if (
        document.getElementById(i + "-page-btn") !== null &&
        document
          .getElementById(i + "-page-btn")
          .classList.contains("active-page")
      ) {
        document.getElementById(parseInt(i - 1) + "-page-btn").click();
      }
    }
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const getUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/profile",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setUserInfo(Res.data);
        checkUserRoleTypes(Res.data);
        checkNotificationRedirect(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchMSSHomepageSummary = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/summary",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setMSSSummary(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const checkUserRoleTypes = (UserInfoData) => {
    if (
      UserInfoData.superAdmin ||
      (UserInfoData.roleTypes &&
        UserInfoData.roleTypes.includes("MANAGER_SELF_SERVICE"))
    ) {
      fetchMSSHomepageSummary();
    }
  };
  const getUserImage = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAvatarURL(Res.data.imageUrl);
        props.GetUserInfo();
      })
      .catch((Err) => {
        console.log(Err);
        setAvatarURL("");
      });
  };
  const getUserHeader = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-background",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        setHeaderURL("");
        console.log(Res);
        if (Res.data.imageUrl.length > 0) {
          setHeaderURL(Res.data.imageUrl);
        }
      })
      .catch((Err) => {
        console.log(Err);
        setHeaderURL("");
      });
  };
  const showActivities = useCallback(() => {
    setTotalElements(TotalActivities);
    updatePages(
      TotalActivities,
      parseInt(document.getElementById("row-per-page-filter").value),
      false,
      true
    );

    let Size = parseInt(document.getElementById("row-per-page-filter").value);

    updateJobs(0, Size);
    updateProjects(0, Size);
    fetchActivities(0, Size, false, MoreLikeThisIsActive);
  }, [TotalActivities]);
  const showJobs = useCallback(() => {
    setTotalElements(TotalJobs);
    let Size = parseInt(document.getElementById("row-per-page-filter").value);

    updatePages(
      TotalJobs,
      parseInt(document.getElementById("row-per-page-filter").value),
      false,
      true
    );
    fetchJobs(null, 0, Size, MoreLikeThisIsActive);
    updateActivities(0, Size);
    updateProjects(0, Size);
  }, [TotalJobs]);
  const showProjects = useCallback(() => {
    setTotalElements(TotalProjects);
    updatePages(
      TotalProjects,
      parseInt(document.getElementById("row-per-page-filter").value),
      false,
      true
    );

    let Size = parseInt(document.getElementById("row-per-page-filter").value);

    updateJobs(0, Size);
    updateActivities(0, Size);
    fetchProjects(0, Size);
  }, [TotalProjects]);

  const switchFooterTabs = (Id) => {
    sliderRef.current.slickGoTo(0);
    if (Id === "recent") {
      document.getElementById("hr-line").style.transform = "none";
      document.getElementById("recent").classList.add("active");
      document.getElementById("popular").classList.remove("active");
      if (document.getElementById("list-wrapper") !== null) {
        document.getElementById("list-wrapper").classList.add("translate-left");
        document
          .getElementById("list-wrapper")
          .classList.remove("translate-right");
      }
      setRecentIsActive(true);
      fetchRecentJPAs();
    } else {
      document.getElementById("hr-line").style.transform = "translateX(82px)";
      document.getElementById("recent").classList.remove("active");
      document.getElementById("popular").classList.add("active");
      setRecentIsActive(false);
      fetchPopularJPAs();
      if (document.getElementById("list-wrapper") !== null) {
        document
          .getElementById("list-wrapper")
          .classList.remove("translate-left");
        document
          .getElementById("list-wrapper")
          .classList.add("translate-right");
      }
    }
  };

  const handleScrollRecent = (Direction) => {
    if (Direction === "right") {
      sliderRef.current.slickNext();
    } else {
      sliderRef.current.slickPrev();
    }
    if (document.getElementById("list-wrapper") !== null) {
      if (Direction === "right") {
        document.getElementById("list-wrapper").scrollLeft += 314;
      } else if (Direction === "left") {
        document.getElementById("list-wrapper").scrollLeft += -314;
      } else {
        return null;
      }
    }
    setTimeout(() => {
      if (document.getElementById("list-wrapper") !== null) {
        let Position = document.getElementById("list-wrapper").scrollLeft;
        let ScrollWidth =
          document.getElementById("list-wrapper").scrollWidth -
          document.getElementById("list-wrapper").clientWidth;
        if (Position > 0) {
          document
            .getElementById("prev-row")
            .classList.remove("disabled-row-switch");
        }
        if (Position === 0) {
          document
            .getElementById("prev-row")
            .classList.add("disabled-row-switch");
        }
        if (Position > ScrollWidth) {
          document
            .getElementById("next-row")
            .classList.add("disabled-row-switch");
        }
        if (Position < ScrollWidth) {
          document
            .getElementById("next-row")
            .classList.remove("disabled-row-switch");
        }
        if (Position === ScrollWidth) {
          document
            .getElementById("next-row")
            .classList.add("disabled-row-switch");
        }
      }
    }, 500);
  };
  // this function maps in the array of present elements and closes other open collapsibles
  const updateJobOpenAcardions = (ClickedElement) => {
    for (let i = 0; i < Jobs.length; i++) {
      if (document.getElementById(i + "-collapsible") !== null) {
        let ClassList = document
          .getElementById(i + "-collapsible")
          .closest("span").classList;
        if (
          ClassList[1] === "is-open" &&
          i + "-collapsible" !== ClickedElement
        ) {
          document.getElementById(i + "-collapsible").click();
        }
      }
    }
  };
  const updateProjOpenAcardions = (ClickedElement) => {
    for (let i = 0; i < Projects.length; i++) {
      if (document.getElementById(i + "-proj-collapsible") !== null) {
        let ClassList = document
          .getElementById(i + "-proj-collapsible")
          .closest("span").classList;
        if (
          ClassList[1] === "is-open" &&
          i + "-proj-collapsible" !== ClickedElement
        ) {
          document.getElementById(i + "-proj-collapsible").click();
        }
      }
    }
  };
  const updateActOpenAcardions = (ClickedElement) => {
    for (let i = 0; i < Activities.length; i++) {
      if (document.getElementById(i + "-act-collapsible") !== null) {
        let ClassList = document
          .getElementById(i + "-act-collapsible")
          .closest("span").classList;
        if (
          ClassList[1] === "is-open" &&
          i + "-act-collapsible" !== ClickedElement
        ) {
          document.getElementById(i + "-act-collapsible").click();
        }
      }
    }
  };

  const showSavedOnly = () => {
    let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
    let TabName;
    TabIds.map((Id) => {
      if (document.getElementById(Id).classList.contains("active")) {
        TabName = Id;
      }
    });
    if (TabName === "jobs-tab") {
      fetchBookmarkedJobs(0);
    } else if (TabName === "projects-tab") {
      fetchBookmarkedProjects(0);
    } else {
      fetchBookmarkedActivities(0);
    }
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 500);
    // currently we don't want to show this animation
    // document.getElementById("content-wrapper").classList.add("fade-in-to-top");
    // setTimeout(() => {
    //   if (document.getElementById("content-wrapper") !== null) {
    //     document
    //       .getElementById("content-wrapper")
    //       .classList.remove("fade-in-to-top");
    //   }
    // }, 500);
  };

  const checkPageChange = (TotalItems, Size) => {
    let Page = Math.ceil(TotalItems / Size);
    if (!Page) {
      setJobResIsEmpty(true);
    } else {
      requestPageNumber(Page);
    }
  };

  const fetchBookmarkedJobs = (Start) => {
    if (MoreLikeThisIsActive) {
      fetchJobs(
        undefined,
        0,
        parseInt(document.getElementById("row-per-page-filter").value),
        true,
        undefined,
        true,
        true
      );
    } else {
      let Req = {
        method: "POST",
        baseURL:
          window._env_.API_URL +
          Config.PositionServiceURL +
          "/api/position/recommendation/search/bookmark",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: {
          size: parseInt(document.getElementById("row-per-page-filter").value),
          start: Start,
          criteria: {
            titleLike: document.getElementById("search-input").value,
          },
        },
      };
      if (returnSelectedCategory() === "cat-1") {
        if (Req.data.criteria.category) {
          delete Req.data.criteria.category;
        }
      } else if (returnSelectedCategory() === "cat-2") {
        Req.data.criteria.category = "EXPLOITATION";
      } else if (returnSelectedCategory() === "cat-3") {
        Req.data.criteria.category = "EXPLORATION";
      }

      axios(Req)
        .then((Res) => {
          setJobs([]);
          console.log(Res);
          setJobs(Res.data.results);
          setTotalElements(Res.data.totalElements);
          updatePages(
            Res.data.totalElements,
            parseInt(document.getElementById("row-per-page-filter").value)
          );
          if (Start === 0) {
            document
              .getElementById("prev-page")
              .classList.add("page-btn-disabled");
            if (
              parseInt(
                1 +
                  parseInt(document.getElementById("row-per-page-filter").value)
              ) > parseInt(Res.data.totalElements)
            ) {
              document.getElementById("start").innerHTML = 1;
              document.getElementById("end").innerHTML = parseInt(
                Res.data.results.length
              );
            } else {
              document.getElementById("start").innerHTML = "1";
              document.getElementById("end").innerHTML = parseInt(
                document.getElementById("row-per-page-filter").value
              );
            }
          } else {
            document.getElementById("start").innerHTML = Start;
            document.getElementById("end").innerHTML = parseInt(
              Start + Res.data.results.length
            );
          }
          if (Res.data.results.length === 0) {
            checkPageChange(
              Res.data.totalElements,
              parseInt(document.getElementById("row-per-page-filter").value)
            );
          } else {
            setJobResIsEmpty(false);
          }
        })
        .catch((Err) => {
          console.log(Err);
        });
    }
  };

  const fetchBookmarkedProjects = (Start) => {
    if (MoreLikeThisIsActive) {
      fetchProjects(
        0,
        parseInt(document.getElementById("row-per-page-filter").value),
        false,
        true,
        MoreLikeThisId,
        false,
        true
      );
    } else {
      let Req = {
        method: "POST",
        baseURL:
          window._env_.API_URL +
          Config.ProjectServiceURL +
          "/api/project/recommendation/search/bookmark",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: {
          size: parseInt(document.getElementById("row-per-page-filter").value),
          start: Start,
          criteria: {
            titleLike: document.getElementById("search-input").value,
          },
        },
      };
      if (returnSelectedCategory() === "cat-1") {
        if (Req.data.criteria.category) {
          delete Req.data.criteria.category;
        }
      } else if (returnSelectedCategory() === "cat-2") {
        Req.data.criteria.category = "EXPLOITATION";
      } else if (returnSelectedCategory() === "cat-3") {
        Req.data.criteria.category = "EXPLORATION";
      }

      axios(Req)
        .then((Res) => {
          setProjects([]);
          console.log(Res);
          setProjects(Res.data.results);

          setTotalElements(Res.data.totalElements);
          updatePages(
            Res.data.totalElements,
            parseInt(document.getElementById("row-per-page-filter").value)
          );

          if (Start === 0) {
            document
              .getElementById("prev-page")
              .classList.add("page-btn-disabled");
            if (
              parseInt(
                1 +
                  parseInt(document.getElementById("row-per-page-filter").value)
              ) > parseInt(Res.data.totalElements)
            ) {
              document.getElementById("start").innerHTML = 1;
              document.getElementById("end").innerHTML = parseInt(
                Res.data.results.length
              );
            } else {
              document.getElementById("start").innerHTML = "1";
              document.getElementById("end").innerHTML = parseInt(
                document.getElementById("row-per-page-filter").value
              );
            }
          } else {
            document.getElementById("start").innerHTML = Start;
            document.getElementById("end").innerHTML = parseInt(
              Start + Res.data.results.length
            );
          }
          if (Res.data.results.length === 0) {
            checkPageChange(
              Res.data.totalElements,
              parseInt(document.getElementById("row-per-page-filter").value)
            );
          } else {
            setProjectResIsEmpty(false);
          }
        })
        .catch((Err) => {
          console.log(Err);
        });
    }
  };

  const fetchBookmarkedActivities = (Start) => {
    if (MoreLikeThisIsActive) {
      fetchActivities(
        0,
        parseInt(document.getElementById("row-per-page-filter").value),
        false,
        true,
        MoreLikeThisId,
        false,
        true
      );
    } else {
      let Req = {
        method: "POST",
        baseURL:
          window._env_.API_URL +
          Config.ActivityServiceURL +
          "/api/activity/recommendation/search/bookmark",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: {
          size: parseInt(document.getElementById("row-per-page-filter").value),
          start: Start,
          criteria: {
            titleLike: document.getElementById("search-input").value,
          },
        },
      };
      if (returnSelectedCategory() === "cat-1") {
        if (Req.data.criteria.category) {
          delete Req.data.criteria.category;
        }
      } else if (returnSelectedCategory() === "cat-2") {
        Req.data.criteria.category = "EXPLOITATION";
      } else if (returnSelectedCategory() === "cat-3") {
        Req.data.criteria.category = "EXPLORATION";
      }

      axios(Req)
        .then((Res) => {
          setActivities([]);
          console.log(Res);
          setActivities(Res.data.results);

          setTotalElements(Res.data.totalElements);
          updatePages(
            Res.data.totalElements,
            parseInt(document.getElementById("row-per-page-filter").value)
          );

          if (Start === 0) {
            document
              .getElementById("prev-page")
              .classList.add("page-btn-disabled");
            if (
              parseInt(
                1 +
                  parseInt(document.getElementById("row-per-page-filter").value)
              ) > parseInt(Res.data.totalElements)
            ) {
              document.getElementById("start").innerHTML = 1;
              document.getElementById("end").innerHTML = parseInt(
                Res.data.results.length
              );
            } else {
              document.getElementById("start").innerHTML = "1";
              document.getElementById("end").innerHTML = parseInt(
                document.getElementById("row-per-page-filter").value
              );
            }
          } else {
            document.getElementById("start").innerHTML = Start;
            document.getElementById("end").innerHTML = parseInt(
              Start + Res.data.results.length
            );
          }
          if (Res.data.results.length === 0) {
            checkPageChange(
              Res.data.totalElements,
              parseInt(document.getElementById("row-per-page-filter").value)
            );
          } else {
            setActivityResIsEmpty(false);
          }
        })
        .catch((Err) => {
          console.log(Err);
        });
    }
  };

  const requestItemDetails = (Data, URLparam) => {
    if (MoreLikeThisIsActive) {
      requestMoreLikeThisItemDetails(Data, URLparam);
    } else {
      requestRecommendationDetails(Data, URLparam);
    }
  };

  const requestMoreLikeThisItemDetails = (Data, URLparam) => {
    let Req = {
      method: "GET",
      baseURL: "",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    if (URLparam === "position") {
      Req.baseURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recommendation/similar/" +
        Data.id +
        "/view";
    } else if (URLparam === "project") {
      Req.baseURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/recommendation/similar/" +
        Data.id +
        "/view";
    } else {
      Req.baseURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/recommendation/similar/" +
        Data.id +
        "/view";
    }

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDetails(Res.data);
        setDetailsIsOpen(true);
        fetchRecentJPAs();
        fetchPopularJPAs();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const requestRecommendationDetails = (Data, URLparam) => {
    setRequestedItem(Data);
    let Req = {
      method: "POST",
      baseURL: "",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {},
    };
    if (URLparam === "position") {
      Req.baseURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recommendation/view";
      Req.data = {
        positionRecommendationId: Data.id,
      };
    } else if (URLparam === "project") {
      Req.baseURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/recommendation/view";
      Req.data = {
        projectRecommendationId: Data.id,
      };
    } else {
      Req.baseURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/recommendation/view";
      Req.data = {
        activityRecommendationId: Data.id,
      };
    }
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDetails(Res.data);
        setDetailsIsOpen(true);
        fetchRecentJPAs();
        fetchPopularJPAs();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const refreshData = (Type) => {
    if (Type === "position") {
      fetchJobs(
        null,
        0,
        parseInt(document.getElementById("row-per-page-filter").value),
        MoreLikeThisIsActive
      );
    } else if (Type === "activity") {
      fetchActivities(
        0,
        parseInt(document.getElementById("row-per-page-filter").value),
        MoreLikeThisIsActive
      );
    } else {
      fetchProjects(
        0,
        parseInt(document.getElementById("row-per-page-filter").value),
        MoreLikeThisIsActive
      );
    }
  };

  const toggleApply = (JPA, ApplicationType) => {
    setApplicationType(ApplicationType);
    setDetailsIsOpen(false);
    // setVerifyIsOpen(true);
    // setAvailabilityDatePickerIsOpen(true);
    setApplyingJobInfo(JPA);
  };

  const toggleCancel = (JPA) => {
    setDetailsIsOpen(false);
    setCancelModalIsOpen(true);
    setApplicationToCancel(JPA);
  };

  const toggleEditHeader = () => {
    if (window.innerWidth > 450) {
      if (HeaderURL.length > 1) {
        setHeaderEditorIsOpen(true);
      } else {
        document.getElementById("header-image").click();
      }
    }
  };
  const handleHeaderImageUploaded = (e) => {
    if (e.target.files[0] === undefined) {
      setHeaderImage(HeaderURL);
      document
        .getElementById("apply-profile-btn")
        .classList.add("apply-disabled");
    } else {
      setHeaderImage(e.target.files[0]);
      setTimeout(() => {
        document
          .getElementById("apply-profile-btn")
          .classList.remove("apply-disabled");
      }, 300);
    }
    setHeaderEditorIsOpen(true);
  };
  const removeHeaderImage = () => {
    setHeaderImage("");
  };
  const changeHeaderImage = () => {
    document.getElementById("header-image").click();
  };

  const toggleEditAvatar = () => {
    if (window.innerWidth <= 450) {
      toggleMobileAvatarMenu();
    }
  };
  const avatarUploaded = (e) => {
    if (e.target.files[0] === undefined) {
      setUploadedAvatar(AvatarURL);
      document
        .getElementById("apply-profile-btn")
        .classList.add("apply-disabled");
    } else {
      setUploadedAvatar(e.target.files[0]);
      setTimeout(() => {
        document
          .getElementById("apply-profile-btn")
          .classList.remove("apply-disabled");
      }, 400);
    }
    setAvatrEditIsOpen(true);
  };
  const removeAvatarImage = () => {
    document.getElementById("profile-image").value = "";
    setUploadedAvatar("");
  };
  const changeAvatarImage = () => {
    document.getElementById("profile-image").click();
  };
  const toggleMobileAvatarMenu = () => {
    setMobileAvatarMenuIsOpen(true);
  };
  const handleMobileMenuAvatarEdit = () => {
    setMobileAvatarMenuIsOpen(false);
    if (UserAvatar.length < 1) {
      document.getElementById("profile-image").click();
    } else {
      setAvatrEditIsOpen(true);
    }
  };
  const closeMobileMenu = () => {
    setMobileAvatarMenuIsOpen(false);
  };

  const clickActivePage = () => {
    let ActivePage;
    Pages.map((Id) => {
      if (
        document.getElementById(Id + "-page-btn") !== null &&
        document
          .getElementById(Id + "-page-btn")
          .classList.contains("active-page")
      ) {
        ActivePage = Id;
        setTimeout(() => {
          document.getElementById(Id + "-page-btn").click();
        }, 300);
      }
    });
  };

  const refreshRecentItems = (reactionId, type, isBookmarked) => {
    fetchRecentJPAs();
    fetchPopularJPAs();
    props.handleJPAReaction(reactionId, type, isBookmarked);
  };

  const closeHeaderUploader = () => {
    setHeaderEditorIsOpen(false);
    setHeaderImage("");
  };

  const closeProfileImageUploader = () => {
    setAvatrEditIsOpen(false);
    setUploadedAvatar("");
  };

  const toggleVerifyInterview = (Job, ActionType) => {
    setInterViewDecision(ActionType);
    console.log(ActionType);
    setApplyingJobInfo(Job);
    setDetailsIsOpen(false);
    setVerifyInterviewIsOpen(true);
  };

  const toggleConfirmResetApplication = (JPAItem) => {
    setApplicationToReset(JPAItem);
    setDetailsIsOpen(false);
    setConfirmResetIsOpen(true);
  };

  const confirmResetApplication = () => {
    let ActionType;
    let ActionURL;

    if (ApplicationToReset.project) {
      ActionURL = Config.ProjectServiceURL;
      ActionType = "project";
    } else if (ApplicationToReset.activity) {
      ActionURL = Config.ActivityServiceURL;
      ActionType = "activity";
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/application/reset/" +
        ApplicationToReset.application.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: ApplicationToReset.application.id,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setConfirmResetIsOpen(false);
        clickActivePage();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // This function has the same logic as goToChatRoom() function in ./Components/JPAItem.js
  const goToChatRoom = () => {
    let JPAId = "";
    let JPATitle = "";
    let WorkCity = "";
    let JPAType = "";
    if (ApplyingJobInfo.project) {
      JPAId = ApplyingJobInfo.project.id;
      JPATitle = ApplyingJobInfo.project.title;
      WorkCity = ApplyingJobInfo.project.workCity;
      JPAType = "project";
    } else if (ApplyingJobInfo.activity) {
      JPAId = ApplyingJobInfo.activity.id;
      JPATitle = ApplyingJobInfo.activity.title;
      WorkCity = ApplyingJobInfo.activity.workCity;
      JPAType = "activity";
    } else {
      JPAId = ApplyingJobInfo.position.id;
      JPATitle = ApplyingJobInfo.position.title;
      WorkCity = ApplyingJobInfo.position.workCity;
      JPAType = "position";
    }
    window.localStorage.setItem("chat_jpaId", JPAId);
    window.localStorage.setItem(
      "chat_recipientId",
      ApplyingJobInfo.reviewer.id
    );
    window.localStorage.setItem("chat_title", JPATitle);
    window.localStorage.setItem("chat_workCiy", WorkCity);
    window.localStorage.setItem("chat_jpaType", JPAType);
    window.localStorage.setItem("chat_source", "APPLICATION");
    setTimeout(() => {
      document.getElementById("communication-toggle").click();
    }, 200);
  };

  // determines wether a specific tab id is currently active
  const tabIsActive = (TabName) => {
    let TabIds = ["projects-tab", "activities-tab", "jobs-tab"];
    let ActiveTab; // the active tab
    TabIds.map((Id) => {
      if (document.getElementById(Id).classList.contains("active")) {
        ActiveTab = Id;
      }
    });
    if (ActiveTab === TabName) {
      return true;
    } else {
      return false;
    }
  };

  const handleSearchJPA = () => {
    let Size = 4;
    // this variable is used to determine which function (fetchJPA or fetchBookmarkedJPA)
    // should be called.
    var BookmarkIsOn = false;
    if (
      !document.getElementById("saved-switch-holder").classList.contains("off")
    ) {
      BookmarkIsOn = true;
    }

    if (parseInt(document.getElementById("row-per-page-filter") !== null)) {
      Size = parseInt(document.getElementById("row-per-page-filter").value);
    }
    setTimeout(() => {
      console.log(BookmarkIsOn + "2");

      if (tabIsActive("jobs-tab")) {
        if (BookmarkIsOn) {
          fetchBookmarkedJobs(0);
        } else {
          fetchJobs("Initial", 0, Size, MoreLikeThisIsActive);
        }
        updatePages(TotalJobs, Size);
      } else if (tabIsActive("projects-tab")) {
        if (BookmarkIsOn) {
          fetchBookmarkedProjects(0);
        } else {
          fetchProjects(0, Size, true, MoreLikeThisIsActive);
        }
        updatePages(TotalProjects, Size);
      } else if (tabIsActive("activities-tab")) {
        if (BookmarkIsOn) {
          fetchBookmarkedActivities(0);
        } else {
          fetchActivities(0, Size, true, MoreLikeThisIsActive);
        }

        updatePages(TotalActivities, Size);
      }
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 100);
  };

  // determening if this JPA is available or not
  // (unavailable JPA is either accepted for someone or deleted)
  const JPAIsAvailable = (JPA) => {
    let Status = "";
    if (JPA.position) {
      Status = JPA.position.recruitmentStatus;
    } else if (JPA.project) {
      Status = JPA.project.recruitmentStatus;
    } else if (JPA.activity) {
      Status = JPA.activity.recruitmentStatus;
    }

    if (Status === "ACCEPTED" || JPA.deleted) {
      return false;
    } else {
      return true;
    }
  };

  // requesting more like this jpa recommendations
  const requestMoreLikeThis = (JPAItem) => {
    //removing the localstorage item since it's not required anymore and hiding the filter element
    window.localStorage.removeItem("notification_jpa_search_data");
    setNotificationJPAFilterIsActive(false);
    setLoadingIsShown(true);

    document.getElementById("saved-switch-holder").classList.add("off");
    setMoreLikeThisIsActive(true);

    let Id;
    let Title;
    if (JPAItem.position) {
      Id = JPAItem.position.id;
      Title = JPAItem.position.title;
    } else if (JPAItem.project) {
      Id = JPAItem.project.id;
      Title = JPAItem.project.title;
    } else if (JPAItem.activity) {
      Id = JPAItem.activity.id;
      Title = JPAItem.activity.title;
    }

    setMoreLikeThisTitle(Title);
    setMoreLikeThisId(Id);

    let Size = parseInt(document.getElementById("row-per-page-filter").value);

    var ActiveTab;
    var RequestURL;
    TabIds.map((Tab) => {
      if (document.getElementById(Tab) === null) {
        ActiveTab = "jobs-tab";
      } else {
        if (document.getElementById(Tab).classList.contains("active")) {
          ActiveTab = Tab;
        }
      }
    });
    if (ActiveTab === "jobs-tab") {
      fetchJobs(undefined, 0, Size, true, Id, true);
    } else if (ActiveTab === "projects-tab") {
      fetchProjects(0, Size, true, true, Id, true);
    } else {
      fetchActivities(0, Size, true, true, Id, true);
    }

    console.log(Id, RequestURL);
  };

  const closeMoreLikeThis = () => {
    document.getElementById("saved-switch-holder").classList.add("off");
    setMoreLikeThisIsActive(false);
    setMoreLikeThisId(undefined);
    setMoreLikeThisTitle("");

    let Size = parseInt(document.getElementById("row-per-page-filter").value);
    var ActiveTab;
    TabIds.map((Tab) => {
      if (document.getElementById(Tab) === null) {
        ActiveTab = "jobs-tab";
      } else {
        if (document.getElementById(Tab).classList.contains("active")) {
          ActiveTab = Tab;
        }
      }
    });
    if (ActiveTab === "jobs-tab") {
      if (
        document.getElementById("saved-switch-holder").classList.contains("off")
      ) {
        fetchJobs(undefined, 0, Size);
      } else {
        fetchBookmarkedJobs(0);
      }
    } else if (ActiveTab === "projects-tab") {
      fetchProjects(0, Size, true);
    } else {
      fetchActivities(0, Size, true);
    }
  };

  // The following functions toggle the nex user walkthrough guide dialog and apply the changes
  // to the states related to the previous dialog item.
  const toggleFirstGuide = () => {
    props.setJPATabsGuideIsOpen(true);
    props.SetJPAItemsGuideIsOpen(false);
  };
  const toggleSecondGuide = () => {
    if (props.GuideHasAdditionalStep) {
      props.SetJPAItemsGuideIsOpen(false);
      props.setJPATabsGuideIsOpen(false);
      props.SetBookmarkedItemsGuideIsOpen(false);
      props.setAdminHomeGuideIsOpen(true);
      document.getElementById("back-to-home-navlink").click();
    } else {
      props.SetJPAItemsGuideIsOpen(true);
      props.setJPATabsGuideIsOpen(false);
      props.SetBookmarkedItemsGuideIsOpen(false);
    }
  };
  const toggleThirdGuide = () => {
    props.SetBookmarkedItemsGuideIsOpen(true);
    props.SetJPAItemsGuideIsOpen(false);
    props.SetFooterJPAsGuideIsOpen(false);
    props.setJPATabsGuideIsOpen(false);
  };
  const toggleFourthGuide = () => {
    props.SetFooterJPAsGuideIsOpen(true);
    props.SetBookmarkedItemsGuideIsOpen(false);
  };
  const toggleFifthGuide = () => {
    props.SetNavBookmarksGuideIsOpen(true);
    props.SetFooterJPAsGuideIsOpen(false);
    props.SetUserProfileGuideIsOpen(false);
  };
  const toggleSixthGuide = () => {
    props.ToggleSixthGuide();
  };
  const ToggleSeventhGuide = () => {
    props.SetSkillRecomGuideIsOpen(true);
    props.SetUserProfileGuideIsOpen(false);
  };
  const toggleEighthGuide = () => {
    props.SetHeaderGuideIsOpen(true);
    props.SetSkillRecomGuideIsOpen(false);
  };

  const returnSelectedCategory = () => {
    let Selected = "cat-1";
    CatIds.map((ItemId) => {
      if (
        document.getElementById(ItemId) &&
        document.getElementById(ItemId).classList.contains("active-category")
      ) {
        Selected = ItemId;
      }
    });

    return Selected;
  };

  const toggleAvailabilityModal = (WillOpen, JPAItem, JPAType) => {
    if (JPAType === "position") {
      setRequestedAvailabilityDetails({
        unit: JPAItem.application.availability?.unit,
        value: JPAItem.application.availability?.value,
        title: JPAItem.position.title,
        location: JPAItem.position.workCity,
        startDate: JPAItem.application.availability?.startDate,
        endDate: JPAItem.application.availability?.endDate,
      });
    } else if (JPAType === "project") {
      setRequestedAvailabilityDetails({
        unit: JPAItem.project.availabilityUnit,
        value: JPAItem.project.availabilityValue,
        title: JPAItem.project.title,
        location: JPAItem.project.workCity,
        startDate: JPAItem.application.availability?.startDate,
        endDate: JPAItem.application.availability?.endDate,
      });
    } else if (JPAType === "activity") {
      setRequestedAvailabilityDetails({
        unit: JPAItem.activity.availabilityUnit,
        value: JPAItem.activity.availabilityValue,
        title: JPAItem.activity.title,
        location: JPAItem.activity.workCity,
        startDate: JPAItem.application.availability?.startDate,
        endDate: JPAItem.application.availability?.endDate,
      });
    }

    if (WillOpen) {
      setAvailabilityModalIsOpen(true);
    } else {
      setAvailabilityModalIsOpen(false);
    }
  };

  return (
    <React.Fragment>
      <input
        type="file"
        accept=".jpg , .png, .jpeg"
        className="hidden"
        id="header-image"
        onChange={(e) => handleHeaderImageUploaded(e)}
      />
      <input
        type="file"
        id="profile-image"
        accept=".jpg , .png, .jpeg"
        className="hidden"
        onChange={(e) => avatarUploaded(e)}
      />
      {MobileAvatarMenuIsOpen ? (
        <MobileAvatarMenu
          CloseMenu={() => closeMobileMenu()}
          ToggleUpload={() => handleMobileMenuAvatarEdit()}
          LangData={props.LangData}
        />
      ) : null}
      {AvatarEditIsOpen ? (
        <ProfileImageUploader
          Close={() => closeProfileImageUploader()}
          RemoveImage={() => removeAvatarImage()}
          ChangeImage={() => changeAvatarImage()}
          FetchImage={() => getUserImage()}
          Image={UploadedAvatar}
          LangData={props.LangData}
        />
      ) : null}
      {HeaderEditorIsOpen ? (
        <div className="is-desktop">
          <HeaderImageUploader
            Close={() => closeHeaderUploader()}
            RemoveImage={() => removeHeaderImage()}
            ChangeImage={() => changeHeaderImage()}
            Image={UploadedHeaderImage}
            LangData={props.LangData}
            FetchImage={() => getUserHeader()}
          />
        </div>
      ) : null}

      {UserInfo ? (
        <div className="main-content homepage">
          {CancelModalIsOpen && ApplicationToCancel !== undefined ? (
            <VerifyCancelModaL
              RequestedItem={ApplicationToCancel}
              CloseModal={() => setCancelModalIsOpen(false)}
              ApplicationType={ApplicationType}
              ClickActivePage={() => clickActivePage()}
              LangData={props.LangData}
              CancelApplication={() => null}
            />
          ) : null}
          {DetailsIsOpen ? (
            <DetailsModal
              Details={Details}
              Close={() => setDetailsIsOpen(false)}
              RefreshData={(Type) => refreshData(Type)}
              ToggleApply={(JPAdata, ApplicationType) =>
                toggleApply(JPAdata, ApplicationType)
              }
              ToggleCancel={(Job) => toggleCancel(Job)}
              HandleVerifyInterview={(Job, ActionType) =>
                toggleVerifyInterview(Job, ActionType)
              }
              Color={Colors[Math.floor(Math.random() * Colors.length)]}
              ToggleConfirmResetApplication={(JPAItem) =>
                toggleConfirmResetApplication(JPAItem)
              }
              LangData={props.LangData}
              IsAvailable={JPAIsAvailable(Details)}
              MoreLikeThisIsActive={MoreLikeThisIsActive}
            />
          ) : null}
          {VerifyIsOpen ? (
            <VerificationModal
              RequestedItem={ApplyingJobInfo}
              CloseModal={() => setVerifyIsOpen(false)}
              ApplicationType={ApplicationType}
              ClickActivePage={() => clickActivePage()}
              LangData={props.LangData}
              MoreLikeThisIsActive={MoreLikeThisIsActive}
            />
          ) : null}
          {VerifyInterviewIsOpen ? (
            <InterviewModal
              CloseModal={() => setVerifyInterviewIsOpen(false)}
              RequestedItem={ApplyingJobInfo}
              ClickActivePage={() => clickActivePage()}
              Decision={InterviewDecision}
              LangData={props.LangData}
              MoreLikeThisIsActive={MoreLikeThisIsActive}
            />
          ) : null}
          {VerifyConnectionIsOpen ? (
            <ConfirmMessageModal
              CloseModal={() => setVerifyConnectIsOpen(false)}
              RequestedItem={ApplyingJobInfo}
              ClickActivePage={() => clickActivePage()}
              LangData={props.LangData}
              ToggleChatRoom={() => goToChatRoom()}
              MoreLikeThisIsActive={MoreLikeThisIsActive}
            />
          ) : null}
          {ConfirmResetIsOpen ? (
            <ConfirmResetModal
              Close={() => setConfirmResetIsOpen(false)}
              RequestedItem={ApplicationToReset}
              ConfirmReset={() => confirmResetApplication()}
              LangData={props.LangData}
            />
          ) : null}
          <ContentHeader PageName={translateText("home")} />
          <div className="content-header">
            <div className="address">
              <p>{translateText("home")}</p>
              {props.IsMSS || UserInfo.superAdmin ? (
                <>
                  {" "}
                  <img src={Circle} alt="." />
                  <p>{translateText("recommendations_uppercase")}</p>
                </>
              ) : null}
            </div>
          </div>
          <HomeHead
            SampleUser={SampleUser}
            EmployeePos={EmployeePos}
            PlusCircle={PlusCircle}
            UserAvatar={AvatarURL}
            HeaderImage={HeaderURL}
            UserInfo={UserInfo}
            LangData={props.LangData}
            ToggleEdit={() => toggleEditHeader()}
            ToggleEditAvatar={() => toggleEditAvatar()}
            Colors={{
              bg: UserInfo.backgroundColorCode,
              text: UserInfo.textColorCode,
            }}
            FetchImage={() => getUserHeader()}
            ToggleAvatarEditor={() => setAvatrEditIsOpen(true)}
            FetchNewJPAs={() => updateJPAs()}
            UserProfileGuideIsOpen={props.UserProfileGuideIsOpen}
            ToggleFifthGuide={() => toggleFifthGuide()}
            ToggleSixthGuide={() => toggleSixthGuide()}
            ToggleSeventhGuide={() => ToggleSeventhGuide()}
            ToggleEighthGuide={() => toggleEighthGuide()}
            SkillRecomGuideIsOpen={props.SkillRecomGuideIsOpen}
            JumpToStep={(Step) => props.JumpToStep(Step)}
            CloseGuide={() => props.CloseGuide()}
            GuideHasAdditionalStep={props.GuideHasAdditionalStep}
          />

          <div className="home-main-content">
            {AvailabilityModalIsOpen && RequestedAvailabilityDetails ? (
              <AvailabilityModal
                Close={() => {
                  setAvailabilityModalIsOpen(false);
                  setRequestedAvailabilityDetails(undefined);
                }}
                IsJPA
                Availability={RequestedAvailabilityDetails}
                LangData={props.LangData}
                Icon={AvailabilityIcon}
                ApplicationType={null}
              />
            ) : null}
            <MainContentHead
              ShowJobs={() => showJobs()}
              ShowActivities={() => showActivities()}
              ShowProjects={() => showProjects()}
              LangData={props.LangData}
              ShowSavedOnly={() => showSavedOnly()}
              ToggleSearch={() => handleSearchJPA()}
              NotificationJPAFilterIsActive={NotificationJPAFilterIsActive}
              setNotificationJPAFilterIsActive={(Bool) =>
                setNotificationJPAFilterIsActive(Bool)
              }
              MoreLikeThisIsActive={MoreLikeThisIsActive}
              MoreLikeThisTitle={MoreLikeThisTitle}
              CloseMoreLikeThis={() => closeMoreLikeThis()}
              DisableMoreLikeThis={() => setMoreLikeThisIsActive(false)}
              LoadingIsShown={LoadingIsShown}
              JPATabsGuideIsOpen={props.JPATabsGuideIsOpen}
              ToggleSecondGuide={() => toggleSecondGuide()}
              BookmarkedItemsGuideIsOpen={props.BookmarkedItemsGuideIsOpen}
              ToggleThirdGuide={() => toggleThirdGuide()}
              ToggleFourthGuide={() => toggleFourthGuide()}
              JumpToStep={(Step) => props.JumpToStep(Step)}
              CloseGuide={() => props.CloseGuide()}
              UpdateDateTime={UpdateDateTime}
              CatIds={CatIds}
              GuideHasAdditionalStep={props.GuideHasAdditionalStep}
            />
            {props.JPAItemsGuideIsOpen ? <div className="overlay"></div> : null}
            <div className="content-wrapper" id="content-wrapper">
              {props.JPAItemsGuideIsOpen ? (
                <JPAItemsGuide
                  LangData={props.LangData}
                  ToggleNextDialog={() => toggleThirdGuide()}
                  TogglePreviousDialog={() => toggleFirstGuide()}
                  JumpToStep={(Step) => props.JumpToStep(Step)}
                  CloseGuide={() => props.CloseGuide()}
                  GuideHasAdditionalStep={props.GuideHasAdditionalStep}
                />
              ) : null}
              {LoadingIsShown ? <LoadingIndicatorCircle /> : null}
              <div className="jpa-wrapper" id="top-jobs">
                {JobResultIsEmpty ? (
                  <FormEmptyState
                    StateName="job"
                    Message={
                      JobsInitEmpty
                        ? translateText("empty_job_recommendation")
                        : returnSelectedCategory() === "cat-3"
                        ? "There are no results based on your interactions with the system (e.g. like a job). Please check again later."
                        : translateText("job_reccomendation_empty_result_text")
                    }
                    ActionButton={null}
                  />
                ) : (
                  <React.Fragment>
                    {Jobs.map((Job, i) => (
                      <JPAItem
                        IsApplied={Job.application === null ? false : true}
                        ApplicationData={
                          Job.application === null || Job.sendConfirmationReset
                            ? null
                            : Job.application
                        }
                        Data={Job}
                        Type="Job"
                        Id={i + "-collapsible"}
                        UpdateOtherOpenStates={() =>
                          updateJobOpenAcardions(i + "-collapsible")
                        }
                        LangData={props.LangData}
                        ReqDetails={(Data) =>
                          requestItemDetails(Data, "position")
                        }
                        ToggleApply={(Job, ApplicationType) =>
                          toggleApply(Job, ApplicationType)
                        }
                        ClickActivePage={() => clickActivePage()}
                        RefreshRecentItems={(reactionId, type, isBookmarked) =>
                          refreshRecentItems(reactionId, type, isBookmarked)
                        }
                        UserInfo={UserInfo}
                        ToggleCancel={(Job) => toggleCancel(Job)}
                        HandleVerifyInterview={(Job, ActionType) =>
                          toggleVerifyInterview(Job, ActionType)
                        }
                        ToggleConfirmResetApplication={(JPAItem) =>
                          toggleConfirmResetApplication(JPAItem)
                        }
                        SetVerifyConnectIsOpen={(IsOpen) =>
                          setVerifyConnectIsOpen(IsOpen)
                        }
                        SetSelectedJPA={(JPAItem) =>
                          setApplyingJobInfo(JPAItem)
                        }
                        IsAvailable={JPAIsAvailable(Job)}
                        MoreLikeThisIsActive={MoreLikeThisIsActive}
                        RequestMoreLikeThis={(Job) => requestMoreLikeThis(Job)}
                        ReactionReasons={ReactionReasons}
                        ToggleAvailabilityModal={() =>
                          toggleAvailabilityModal(true, Job, "position")
                        }
                        AvailabilityModalData={RequestedAvailabilityDetails}
                      />
                    ))}
                  </React.Fragment>
                )}
              </div>
              <div className="jpa-wrapper" id="top-projects">
                {ProjectResultIsEmpty ? (
                  <FormEmptyState
                    StateName="project"
                    Message={
                      ProjectsInitEmpty
                        ? translateText("empty_project_recommendation")
                        : returnSelectedCategory() === "cat-3"
                        ? "There are no results based on your interactions with the system (e.g. like a project). Please check again later."
                        : translateText(
                            "project_reccomendation_empty_result_text"
                          )
                    }
                    ActionButton={null}
                  />
                ) : (
                  <React.Fragment>
                    {Projects.map((Project, i) => (
                      <JPAItem
                        IsApplied={Project.application === null ? false : true}
                        ApplicationData={
                          Project.application === null ||
                          Project.sendConfirmationReset
                            ? null
                            : Project.application
                        }
                        Id={i + "-proj-collapsible"}
                        Data={Project}
                        Type="Project"
                        UpdateOtherOpenStates={() =>
                          updateProjOpenAcardions(i + "-collapsible")
                        }
                        LangData={props.LangData}
                        ReqDetails={(Data) =>
                          requestItemDetails(Data, "project")
                        }
                        ToggleApply={(Job, ApplicationType) =>
                          toggleApply(Job, ApplicationType)
                        }
                        ClickActivePage={() => clickActivePage()}
                        RefreshRecentItems={(reactionId, type, isBookmarked) =>
                          refreshRecentItems(reactionId, type, isBookmarked)
                        }
                        UserInfo={UserInfo}
                        ToggleCancel={(Job) => toggleCancel(Job)}
                        HandleVerifyInterview={(Job, ActionType) =>
                          toggleVerifyInterview(Job, ActionType)
                        }
                        ToggleConfirmResetApplication={(JPAItem) =>
                          toggleConfirmResetApplication(JPAItem)
                        }
                        SetVerifyConnectIsOpen={(IsOpen) =>
                          setVerifyConnectIsOpen(IsOpen)
                        }
                        SetSelectedJPA={(JPAItem) =>
                          setApplyingJobInfo(JPAItem)
                        }
                        IsAvailable={JPAIsAvailable(Project)}
                        RequestMoreLikeThis={(Job) => requestMoreLikeThis(Job)}
                        MoreLikeThisIsActive={MoreLikeThisIsActive}
                        ReactionReasons={ReactionReasons}
                        ToggleAvailabilityModal={() =>
                          toggleAvailabilityModal(true, Project, "project")
                        }
                        AvailabilityModalData={RequestedAvailabilityDetails}
                      />
                    ))}
                  </React.Fragment>
                )}
              </div>
              <div className="jpa-wrapper" id="top-activities">
                {ActivityResultIsEmpty ? (
                  <FormEmptyState
                    StateName="activity"
                    Message={
                      ActivitiesInitEmpty
                        ? translateText("empty_activity_recommendation")
                        : returnSelectedCategory() === "cat-3"
                        ? "There are no results based on your interactions with the system (e.g. like an activity). Please check again later."
                        : translateText(
                            "activity_reccomendation_empty_result_text"
                          )
                    }
                    ActionButton={null}
                  />
                ) : (
                  <React.Fragment>
                    {Activities.map((Activity, i) => (
                      <JPAItem
                        IsApplied={Activity.application === null ? false : true}
                        ApplicationData={
                          Activity.application === null ||
                          Activity.sendConfirmationReset
                            ? null
                            : Activity.application
                        }
                        Id={i + "-act-collapsible"}
                        Type="Activity"
                        Data={Activity}
                        UpdateOtherOpenStates={() =>
                          updateActOpenAcardions(i + "-collapsible")
                        }
                        LangData={props.LangData}
                        ReqDetails={(Data) =>
                          requestItemDetails(Data, "activity")
                        }
                        ToggleApply={(Job, ApplicationType) =>
                          toggleApply(Job, ApplicationType)
                        }
                        ClickActivePage={() => clickActivePage()}
                        RefreshRecentItems={(reactionId, type, isBookmarked) =>
                          refreshRecentItems(reactionId, type, isBookmarked)
                        }
                        UserInfo={UserInfo}
                        ToggleCancel={(Job) => toggleCancel(Job)}
                        HandleVerifyInterview={(Job, ActionType) =>
                          toggleVerifyInterview(Job, ActionType)
                        }
                        ToggleConfirmResetApplication={(JPAItem) =>
                          toggleConfirmResetApplication(JPAItem)
                        }
                        SetVerifyConnectIsOpen={(IsOpen) =>
                          setVerifyConnectIsOpen(IsOpen)
                        }
                        SetSelectedJPA={(JPAItem) =>
                          setApplyingJobInfo(JPAItem)
                        }
                        IsAvailable={JPAIsAvailable(Activity)}
                        RequestMoreLikeThis={(Job) => requestMoreLikeThis(Job)}
                        MoreLikeThisIsActive={MoreLikeThisIsActive}
                        ReactionReasons={ReactionReasons}
                        ToggleAvailabilityModal={() =>
                          toggleAvailabilityModal(true, Activity, "activity")
                        }
                        AvailabilityModalData={RequestedAvailabilityDetails}
                      />
                    ))}
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="content-pagination">
              <div className="info-footer" id="info-footer">
                <div className="pagenumber-summary">
                  {translateText("showing")} <p id="start">1</p>
                  {translateText("to")} <p id="end">4</p>
                  {translateText("of")} {TotalElements} {translateText("items")}
                  .
                </div>
                <section className="pagination-holder">
                  <button
                    onClick={() => requestPrevPage()}
                    id="prev-page"
                    className="page-btn page-btn-disabled"
                  >
                    <i className="feather-chevron-left"></i>
                  </button>
                  <React.Fragment>
                    {Pages.length < 6 ? (
                      <React.Fragment>
                        {Pages.map((Page) => (
                          <React.Fragment>
                            {Page === 1 ? (
                              <button
                                key={Page}
                                onClick={() => requestPageNumber(Page)}
                                className="page-btn active-page"
                                id={Page + "-page-btn"}
                              >
                                {Page}
                              </button>
                            ) : (
                              <button
                                key={Page}
                                onClick={() => requestPageNumber(Page)}
                                className="page-btn"
                                id={Page + "-page-btn"}
                              >
                                {Page}
                              </button>
                            )}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <button
                          onClick={() => requestPageNumber(1)}
                          className="page-btn active-page"
                          id={1 + "-page-btn"}
                        >
                          {1}
                        </button>
                        {PageInfo.FirstDotsShown ? <p>...</p> : null}
                        <button
                          onClick={() =>
                            requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                          }
                          className="page-btn"
                          id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                        >
                          {parseInt(PageInfo.MiddlePage - 1)}
                        </button>
                        {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                          <button
                            onClick={() =>
                              requestPageNumber(PageInfo.MiddlePage)
                            }
                            className="page-btn"
                            id={PageInfo.MiddlePage + "-page-btn"}
                          >
                            {PageInfo.MiddlePage}
                          </button>
                        )}
                        {parseInt(PageInfo.MiddlePage + 1) >=
                        PageInfo.LastPage ? null : (
                          <button
                            onClick={() =>
                              requestPageNumber(
                                parseInt(PageInfo.MiddlePage + 1)
                              )
                            }
                            className="page-btn "
                            id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                          >
                            {parseInt(PageInfo.MiddlePage + 1)}
                          </button>
                        )}
                        {!PageInfo.LastDotsShown ? <p>...</p> : null}
                        <button
                          onClick={() => requestPageNumber(PageInfo.LastPage)}
                          className="page-btn"
                          id={PageInfo.LastPage + "-page-btn"}
                        >
                          {PageInfo.LastPage}
                        </button>
                      </React.Fragment>
                    )}
                  </React.Fragment>

                  {Pages.length === 1 ? (
                    <button
                      onClick={() => requestNextPage()}
                      id="next-page"
                      className="page-btn page-btn-disabled"
                    >
                      <i className="feather-chevron-right"></i>
                    </button>
                  ) : (
                    <button
                      onClick={() => requestNextPage()}
                      id="next-page"
                      className="page-btn"
                    >
                      <i className="feather-chevron-right"></i>
                    </button>
                  )}
                </section>
                <div className="row-count-select">
                  <p className="row-info">{translateText("items_per_page")}</p>
                  <Select
                    Initial={"4"}
                    Options={SizeOptions}
                    IsWithId
                    PreSelected
                    PreSelectedId="4"
                    Id={"row-per-page"}
                    ChangeHandler={() =>
                      setTimeout(() => {
                        handleSizeChange();
                      }, 100)
                    }
                    ValidationError=""
                  />
                </div>
              </div>
            </div>
          </div>
          {props.FooterJPAsGuideIsOpen ? <div className="overlay"></div> : null}
          <div className="recently-viewed" id="recently-viewed">
            {/* { ? (
            <div className="action-disabler-footer"></div>
          ) : null} */}
            {props.FooterJPAsGuideIsOpen ? (
              <FooterJPAsGuide
                LangData={props.LangData}
                ToggleNextDialog={() => toggleFifthGuide()}
                TogglePreviousDialog={() => toggleThirdGuide()}
                JumpToStep={(Step) => props.JumpToStep(Step)}
                CloseGuide={() => props.CloseGuide()}
                GuideHasAdditionalStep={props.GuideHasAdditionalStep}
              />
            ) : null}
            <section
              className="head"
              style={
                props.FooterJPAsGuideIsOpen ? { pointerEvents: "none" } : null
              }
            >
              <h1 className="footer-title">
                {RecentIsActive
                  ? translateText("recently_viewed")
                  : translateText("popular_opportunities")}
              </h1>
              <div className="head-tabs">
                <span
                  className="tab-tiem active"
                  onClick={() => switchFooterTabs("recent")}
                  id="recent"
                >
                  {translateText("recent")}
                </span>
                <span id="hr-line"></span>
                <span className="vr-line"></span>
                <span
                  className="tab-tiem"
                  onClick={() => switchFooterTabs("popular")}
                  id="popular"
                >
                  {translateText("popular")}
                </span>
              </div>
            </section>
            <section
              className="recently-viewed-row"
              style={
                props.FooterJPAsGuideIsOpen ? { pointerEvents: "none" } : null
              }
            >
              <button
                className="recent-row-switch"
                id="prev-row"
                onClick={() => handleScrollRecent("left")}
              >
                <i className="feather-chevron-left"></i>
              </button>
              <Slider {...CarouselConfig} ref={sliderRef}>
                {RecentIsActive
                  ? RecentJPAs.map((Item) => (
                      <div>
                        <RecentViewedCard
                          key={Item.id}
                          Id={Item.id + "-recent"}
                          SampleUser={SampleUser}
                          UserInfo={UserInfo}
                          Data={Item}
                          Colors={Colors}
                          LangData={props.LangData}
                          IsRecent
                          RefreshJPAs={() => clickActivePage()}
                        />
                      </div>
                    ))
                  : PopularJPAs.map((Item) => (
                      <div>
                        <RecentViewedCard
                          key={Item.id}
                          Id={Item.id + "-recent"}
                          SampleUser={SampleUser}
                          Data={Item}
                          UserInfo={UserInfo}
                          Colors={Colors}
                          LangData={props.LangData}
                          RefreshJPAs={() => clickActivePage()}
                        />
                      </div>
                    ))}
              </Slider>
              <button
                className="recent-row-switch"
                onClick={() => handleScrollRecent("right")}
                id="next-row"
              >
                <i className="feather-chevron-right"></i>
              </button>
            </section>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default ESSHome;
